import { TextField } from "@mui/material";

import FormField from "../../../../global/FormComponents/field/FormField";

const ActionDetailField = ({ actionDetail, setActionDetail, handleActionDetailFocus }) => (
  <FormField label="Action Detail">
    <TextField
      multiline
      placeholder="Action Detail"
      name="Action Detail"
      value={actionDetail}
      InputLabelProps={{ shrink: true }}
      onChange={(event) => setActionDetail(event.target.value)}
      onFocus={handleActionDetailFocus}
      minRows={3}
      maxRows={10}
      variant="outlined"
    />
  </FormField>
);

export default ActionDetailField;
